/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EvolveLogData model module.
 * @module model/EvolveLogData
 * @version 1.0
 */
class EvolveLogData {
    /**
     * Constructs a new <code>EvolveLogData</code>.
     * @alias module:model/EvolveLogData
     */
    constructor() { 
        
        EvolveLogData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EvolveLogData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EvolveLogData} obj Optional instance to populate.
     * @return {module:model/EvolveLogData} The populated <code>EvolveLogData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EvolveLogData();

            if (data.hasOwnProperty('nftMergeNo')) {
                obj['nftMergeNo'] = ApiClient.convertToType(data['nftMergeNo'], 'Number');
            }
            if (data.hasOwnProperty('nftUid1')) {
                obj['nftUid1'] = ApiClient.convertToType(data['nftUid1'], 'Number');
            }
            if (data.hasOwnProperty('nftUid2')) {
                obj['nftUid2'] = ApiClient.convertToType(data['nftUid2'], 'Number');
            }
            if (data.hasOwnProperty('nftUid3')) {
                obj['nftUid3'] = ApiClient.convertToType(data['nftUid3'], 'Number');
            }
            if (data.hasOwnProperty('nftUid4')) {
                obj['nftUid4'] = ApiClient.convertToType(data['nftUid4'], 'Number');
            }
            if (data.hasOwnProperty('nftUid5')) {
                obj['nftUid5'] = ApiClient.convertToType(data['nftUid5'], 'Number');
            }
            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('mergeTransactionNo')) {
                obj['mergeTransactionNo'] = ApiClient.convertToType(data['mergeTransactionNo'], 'Number');
            }
            if (data.hasOwnProperty('xper')) {
                obj['xper'] = ApiClient.convertToType(data['xper'], 'Number');
            }
            if (data.hasOwnProperty('per')) {
                obj['per'] = ApiClient.convertToType(data['per'], 'Number');
            }
            if (data.hasOwnProperty('itemUsed')) {
                obj['itemUsed'] = ApiClient.convertToType(data['itemUsed'], 'Boolean');
            }
            if (data.hasOwnProperty('superBoosterUsed')) {
                obj['superBoosterUsed'] = ApiClient.convertToType(data['superBoosterUsed'], 'Boolean');
            }
            if (data.hasOwnProperty('boosterUsed')) {
                obj['boosterUsed'] = ApiClient.convertToType(data['boosterUsed'], 'Boolean');
            }
            if (data.hasOwnProperty('engineCount')) {
                obj['engineCount'] = ApiClient.convertToType(data['engineCount'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EvolveLogData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EvolveLogData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }

        return true;
    }


}



/**
 * @member {Number} nftMergeNo
 */
EvolveLogData.prototype['nftMergeNo'] = undefined;

/**
 * @member {Number} nftUid1
 */
EvolveLogData.prototype['nftUid1'] = undefined;

/**
 * @member {Number} nftUid2
 */
EvolveLogData.prototype['nftUid2'] = undefined;

/**
 * @member {Number} nftUid3
 */
EvolveLogData.prototype['nftUid3'] = undefined;

/**
 * @member {Number} nftUid4
 */
EvolveLogData.prototype['nftUid4'] = undefined;

/**
 * @member {Number} nftUid5
 */
EvolveLogData.prototype['nftUid5'] = undefined;

/**
 * @member {Number} nftUid
 */
EvolveLogData.prototype['nftUid'] = undefined;

/**
 * @member {Number} accountNo
 */
EvolveLogData.prototype['accountNo'] = undefined;

/**
 * @member {String} email
 */
EvolveLogData.prototype['email'] = undefined;

/**
 * @member {Number} mergeTransactionNo
 */
EvolveLogData.prototype['mergeTransactionNo'] = undefined;

/**
 * @member {Number} xper
 */
EvolveLogData.prototype['xper'] = undefined;

/**
 * @member {Number} per
 */
EvolveLogData.prototype['per'] = undefined;

/**
 * @member {Boolean} itemUsed
 */
EvolveLogData.prototype['itemUsed'] = undefined;

/**
 * @member {Boolean} superBoosterUsed
 */
EvolveLogData.prototype['superBoosterUsed'] = undefined;

/**
 * @member {Boolean} boosterUsed
 */
EvolveLogData.prototype['boosterUsed'] = undefined;

/**
 * @member {Number} engineCount
 */
EvolveLogData.prototype['engineCount'] = undefined;

/**
 * @member {Date} createdAt
 */
EvolveLogData.prototype['createdAt'] = undefined;

/**
 * @member {Date} updatedAt
 */
EvolveLogData.prototype['updatedAt'] = undefined;






export default EvolveLogData;

